/**  @jsx jsx */

import { Grid, IconButton } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  wrapper: css`
    display: inline-block;
  `,
};

type Props = {
  isDisabledMoveDown: boolean;
  isDisabledMoveUp: boolean;
  onMoveDown: () => void;
  onMoveUp: () => void;
};

function SortControls(props: Props) {
  const { isDisabledMoveDown, isDisabledMoveUp, onMoveDown, onMoveUp } = props;

  return (
    <div
      css={Styles.wrapper}
      onClick={event => event.stopPropagation()}
      role="presentation"
    >
      <Grid columns="repeat(2, 24px)" gap={8}>
        <IconButton
          aria-label="Sort item up one"
          color="icon-primary"
          disabled={isDisabledMoveUp}
          icon="arrowBigUp"
          onClick={onMoveUp}
        />
        <IconButton
          aria-label="Sort item down one"
          color="icon-primary"
          disabled={isDisabledMoveDown}
          icon="arrowBigDown"
          onClick={onMoveDown}
        />
      </Grid>
    </div>
  );
}

export default SortControls;
